import React, { Component } from "react";
import { Card, Badge, CustomInput, Collapse, Button } from "reactstrap";
import { connect } from "react-redux";
import {
  setContainerClassnames,
  clickOnMobileMenu,
} from "../../../redux/actions";
import IntlMessages from "../../../helpers/IntlMessages";
import classnames from "classnames";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import { AddCommaNumber, AddCommaPhoneNumber } from "../../../helpers/Utils";

class LabelItemLeft extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isTransactionOpen: false,
    };
  }

  menuButtonClick = (e, menuClickCount, containerClassnames) => {
    setTimeout(() => {
      var event = document.createEvent("HTMLEvents");
      event.initEvent("resize", false, false);
      window.dispatchEvent(event);
    }, 350);
    this.props.setContainerClassnames(
      menuClickCount,
      containerClassnames,
      this.props.selectedMenuHasSubItems,
    );
  };

  onClickedItem = (item) => {
    this.props.onClickedItem(
      // callback
      item,
      this.menuButtonClick,
      [null, 1000, this.props.containerClassnames],
    );
  };

  toggleTransaction = (e) => {
    e.stopPropagation();
    this.setState((prev) => ({
      ...prev,
      isTransactionOpen: !this.state.isTransactionOpen,
    }));
  };

  render() {
    const { isTransactionOpen } = this.state;
    const {
      item,
      setting,
      isDisabledUpdate,
      toggleItemLogFunc,
      selectedItems,
      onChangeCheckbox,
      idx,
    } = this.props;

    const totalValueSum = item.company_provider_item.reduce(
      (accumulator, currentItem) => {
        // Sử dụng price_income từ CompanyProviderItem thay vì stock.total_value
        // để hiển thị tổng giá trị riêng cho từng nhà cung cấp
        if (currentItem && typeof currentItem.price_income === "number") {
          return accumulator + currentItem.price_income;
        }
        // Fallback: thử parse từ string nếu price_income là string
        if (currentItem && currentItem.price_income) {
          return accumulator + (Number(currentItem.price_income) || 0);
        }
        return accumulator;
      },
      0,
    );

    return (
      <Card className="mb-3 custom-shadow">
        <div className="d-flex flex-column cursor-pointer">
          <div className={"d-flex flex-grow-1 min-width-zero"}>
            <div
              className="custom-control custom-checkbox pl-4 align-self-center cursor-pointer"
              style={{ cursor: "pointer" }}
            >
              <CustomInput
                className="custom-checkbox mb-0 d-inline-block cursor-pointer"
                style={{ cursor: "pointer" }}
                type="checkbox"
                id={`provider-${item.id}`}
                checked={selectedItems.includes(item.id)}
                onChange={(e) => {
                  e.stopPropagation();
                  onChangeCheckbox(item.id);
                }}
                onClick={(e) => e.stopPropagation()}
                label=""
              />
            </div>
            {item.at ? (
              <div
                onClick={() => this.props.onUpdate(item)}
                className={classnames(
                  "card-body align-self-center d-flex flex-ssm-column justify-content-between min-width-zero py-3",
                  {
                    "flex-lg-row align-items-lg-center": !setting.update,
                  },
                )}
              >
                <div className="align-self-center d-flex flex-column justify-content-between">
                  <div className="w-80 list-item-heading mb-1 truncate d-block w-sm-100">
                    <span>{item.name}</span>
                  </div>
                  <div className="text-muted text-small">
                    {item.email && item.email}{" "}
                    {item.email && item.address && " / "}{" "}
                    {item.address && `Địa chỉ: ${item.address}`}
                  </div>
                  <div className="text-muted text-small mt-3">
                    Công nợ: {AddCommaNumber(item.total_price_pending)}đ / Tổng
                    nhập: {AddCommaNumber(totalValueSum)}đ
                  </div>
                </div>
                <div className="w-20">
                  <Badge color={"primary"} pill>
                    {item.phone}
                  </Badge>
                </div>
              </div>
            ) : (
              <div
                onClick={() => this.props.onUpdate(item)}
                className="card-body w-100 align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center py-3"
              >
                <div className="align-self-center d-flex flex-column justify-content-between">
                  <div className="w-80 list-item-heading mb-1 truncate d-block w-sm-100">
                    <span>{item.name}</span>
                  </div>
                  <div className="text-muted text-small">
                    {item.email && item.email}{" "}
                    {item.email && item.address && " / "}{" "}
                    {item.address && `Địa chỉ: ${item.address}`}
                  </div>
                  <div className="text-muted text-small mt-3">
                    <span
                      className={item.total_price_pending > 0 && "text-primary"}
                    >
                      Công nợ: {AddCommaNumber(item.total_price_pending)}đ
                    </span>{" "}
                    / Tổng nhập: {AddCommaNumber(totalValueSum)}đ
                  </div>
                </div>
                <div className="w-20 w-sm-100">
                  <Badge color={"primary"} pill>
                    {item.phone}
                  </Badge>
                </div>
              </div>
            )}
            <div className="w-15 d-flex flex-column justify-content-center align-items-end align-self-center pr-4">
              {item.company_provider_item &&
              item.company_provider_item.length ? (
                <div
                  className="d-flex align-items-center text-small text-muted"
                  onClick={this.toggleTransaction}
                  style={{ cursor: "pointer" }}
                >
                  <div>
                    <IntlMessages id="company-provider.transaction" /> (
                    {item.company_provider_item.length})
                  </div>{" "}
                  <i
                    className={`simple-icon-arrow-${
                      isTransactionOpen ? "up" : "down"
                    } ml-1`}
                  />
                </div>
              ) : null}
            </div>
          </div>
          {item?.company_provider_item &&
            item.company_provider_item.length > 0 && (
              <Collapse isOpen={isTransactionOpen} className="mt-3">
                <div className="d-flex font-weight-bold border-bottom pb-2">
                  <div className="d-flex w-100 px-3">
                    <Colxx xxs="2">
                      <IntlMessages id="company-provider.item_product" />
                    </Colxx>
                    <Colxx xxs="2">
                      <IntlMessages id="company-provider.sku" />
                    </Colxx>
                    <Colxx xxs="1">SL</Colxx>
                    <Colxx xxs="1">
                      <IntlMessages id="company-provider.price_new" />
                    </Colxx>
                    <Colxx xxs="2">
                      <IntlMessages id="company-provider.total" />
                    </Colxx>
                    <Colxx xxs="1">
                      <IntlMessages id="company-provider.debt" />
                    </Colxx>
                    <Colxx xxs="2">
                      <IntlMessages id="company-provider.time" />
                    </Colxx>
                    <Colxx xxs="1" className="d-flex justify-content-end">
                      <IntlMessages id="company-provider.action" />
                    </Colxx>
                  </div>
                </div>
                {[...item.company_provider_item].map((c, idx) => {
                  return (
                    <div className="d-flex my-3" key={idx}>
                      <div className="d-flex align-items-center w-100 px-3">
                        <Colxx xxs="2">{c.name}</Colxx>
                        <Colxx xxs="2">{c?.stock?.sku}</Colxx>
                        <Colxx xxs="1">{c.quantity || "-"}</Colxx>
                        <Colxx xxs="1">
                          {AddCommaNumber(c?.stock?.price_new)}
                        </Colxx>
                        <Colxx xxs="2">{AddCommaNumber(c.price_income)}</Colxx>
                        <Colxx xxs="1">{AddCommaNumber(c.price_pending)}</Colxx>
                        <Colxx xxs="2" style={{ whiteSpace: "nowrap" }}>
                          {c.date}
                        </Colxx>
                        <Colxx xxs="1" className="d-flex justify-content-end">
                          {c.price_pending && c.price_pending > 0 ? (
                            <Button
                              color="primary"
                              size="xs"
                              className={classnames({
                                disable: isDisabledUpdate,
                              })}
                              onClick={() => toggleItemLogFunc(c)}
                            >
                              <IntlMessages id="company-provider.title-log-add-more" />
                            </Button>
                          ) : (
                            ""
                          )}
                        </Colxx>
                      </div>
                    </div>
                  );
                })}
              </Collapse>
            )}
        </div>
      </Card>
    );
  }
}

const mapStateToProps = ({ menu }) => {
  const { containerClassnames, menuClickCount, selectedMenuHasSubItems } = menu;
  return {
    containerClassnames,
    menuClickCount,
    selectedMenuHasSubItems,
  };
};
export default connect(mapStateToProps, {
  setContainerClassnames,
  clickOnMobileMenu,
})(LabelItemLeft);
